<template>
  <section class="services">
    <div class="cut-shape">
      <div class="triangle triangle1"></div>
      <div class="triangle triangle2"></div>
      <div class="triangle triangle5"></div>
      <div class="triangle triangle6"></div>
      <div class="triangle triangle7"></div>

      <v-layout wrap justify-center align-center>
        <v-flex xs12 sm6 md6 lg6>
          <div data-aos="zoom-in-right">
            <h2 class="text-center font-weight-bold white--text mb-6">Our Services</h2>
            <v-layout wrap justify-end>
              <v-flex xs12 lg8>
                <ul class="services-list">
                  <li v-for="(service, i) in services" :key="i" class="service-list-item">
                    <span class="glass-bullet">
                      <v-icon small color="#fff">mdi-check</v-icon>
                    </span>
                    <span class="service-text">{{ service }}</span>
                  </li>
                </ul>
              </v-flex>
            </v-layout>
          </div>
        </v-flex>

        <v-flex xs12 sm6 md5 lg6>
          <div data-aos="fade-left">
            <OhYesCard />
          </div>
        </v-flex>
      </v-layout>
    </div>
  </section>
</template>

<script>
import OhYesCard from './OhYesCard.vue';

export default {
  name: 'ServicesSection',
  components: { OhYesCard },
  props: {
    services: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
@import 'https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css';
@import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@400;600;700&display=swap');

.services {
  font-family: 'Nunito Sans', sans-serif;
  position: relative;
  background: white;
}

.cut-shape {
  background: linear-gradient(135deg, #ff9800, #f46523);
  background-attachment: fixed;
  padding: 100px 20px;
  clip-path: polygon(0 10%, 100% 0, 100% 90%, 0 100%);
  position: relative;
  overflow: hidden;
}

.services-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.service-list-item {
  display: flex;
  align-items: center;
  gap: 15px;
  margin: 16px 0;
}

.glass-bullet {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(6px);
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  flex-shrink: 0;
}

.service-text {
  font-family: 'Nunito Sans', sans-serif;
  font-weight: 800;
  font-size: clamp(1rem, 0.5vw + 0.9rem, 1.2rem);
  color: #fff;
}

.triangle {
  position: absolute;
  width: 0;
  height: 0;
  border-left: 40px solid transparent;
  border-right: 40px solid transparent;
  border-bottom: 70px solid rgba(255, 255, 255, 0.15);
  animation: float 6s ease-in-out infinite;
}

.triangle1 {
  top: 60px;
  left: 10%;
}
.triangle2 {
  top: 50px;
  left: 60%;
  border-bottom-color: rgba(255, 255, 255, 0.2);
  animation-delay: 2s;
}
.triangle5 {
  top: 400px;
  left: 75%;
  border-bottom-color: rgba(255, 255, 255, 0.1);
  animation-delay: 4s;
}
.triangle6 {
  top: 320px;
  left: 15%;
  border-bottom-color: rgba(255, 255, 255, 0.1);
  animation-delay: 4s;
}
.triangle7 {
  top: 720px;
  left: 25%;
  border-bottom-color: rgba(255, 255, 255, 0.1);
  animation-delay: 4s;
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(-20px) rotate(15deg);
  }
}

@media (max-width: 768px) {
  .services-left {
    padding: 20px;
    text-align: center;
  }
  .triangle {
    display: none;
  }
}

@media (max-width: 480px) {
  .service-text {
    font-size: 0.9rem;
  }
}
</style>
